import { render, staticRenderFns } from "./homeInfo.vue?vue&type=template&id=edf1faba&scoped=true&"
import script from "./homeInfo.vue?vue&type=script&lang=js&"
export * from "./homeInfo.vue?vue&type=script&lang=js&"
import style0 from "./homeInfo.vue?vue&type=style&index=0&id=edf1faba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf1faba",
  null
  
)

export default component.exports